import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICONS } from './svg-sprite.constants';

@Injectable({
  providedIn: 'root',
})
export class CbreIconLoaderService {
  private _safeSvgMap = new Map<string, SafeHtml>();
  constructor(
    private matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer
  ) {
    for (const icon of ICONS) {
      const trustedSvg = domSanitizer.bypassSecurityTrustHtml(icon.source);
      this._safeSvgMap.set(icon.label, trustedSvg);
      this.matIconRegistry.addSvgIconLiteral(icon.label, trustedSvg);
    }
  }

  public getTrustedIcon(iconName: string): SafeHtml {
    return this._safeSvgMap.get(iconName);
  }
}
